// A reusable, accessible TTS button. Returns an HTML string so it composes
// freely inside template-literal views. A single delegated click handler
// dispatches all buttons via a registry — that means thousands of cards
// can coexist with one event listener.

import { speak, ttsAvailable } from '../utils/tts.js';

let counter = 0;
const registry = new Map(); // id → text to speak

export function AudioButton(text, { size = 'md', label } = {}) {
  if (!ttsAvailable()) return '';

  const id = `aud-${++counter}`;
  registry.set(id, text);

  const sizeClass =
    size === 'sm' ? 'w-7 h-7'  :
    size === 'lg' ? 'w-12 h-12' :
                    'w-9 h-9';

  const ariaLabel = label || `Play pronunciation: ${text.replace(/"/g, '&quot;')}`;

  return `
    <button type="button"
            data-audio="${id}"
            aria-label="${ariaLabel}"
            class="audio-btn ${sizeClass} shrink-0">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
           class="w-1/2 h-1/2">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
        <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
      </svg>
    </button>
  `;
}

// Single delegated listener — keeps the DOM lean.
if (typeof document !== 'undefined') {
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-audio]');
    if (!btn) return;
    const id = btn.getAttribute('data-audio');
    const text = registry.get(id);
    if (!text) return;
    speak(text, {
      onStart: () => btn.classList.add('playing'),
      onEnd:   () => btn.classList.remove('playing'),
    });
  });
}
